import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import { BASE_URL, getNewList } from '../api/api'
import { Link, useParams } from 'react-router-dom'
import Pagination from './pagination'
import useMediaQuery from '../hooks/useMediaQuery'
import bofang from '../images/bofang.png'
import NavLink from './navLink'

const Zjxc = () => {
  const { channel_id = 1, page = 1 } = useParams()
  const pagesize = 20

  const [data, setData] = useState([])

  useEffect(() => {
    getNewList(
      `archives/newsList?pagesize=${pagesize}&channel_id=${channel_id}&page=${page}`.replace(
        '.html',
        ''
      )
    ).then(res => {
      setData(res?.data)
      // console.log(res)
    })
  }, [pagesize, channel_id, page])
  const isMobile = useMediaQuery()

  return (
    <Layout>
      <Subpages className="px-5 lg:px-0" name="直击现场">
        <div className="flex flex-col lg:flex-row mb-10 lg:mb-0 flex-wrap justify-between gap-[42px]">
          {data?.list?.data?.map(({ id, title, image = '', title1 = '', outlink }, key) => (
            <div className=" relative" key={id}>
              <div>
                <img
                  style={{ width: isMobile ? '100%' : 578, height: 311 }}
                  src={`${BASE_URL}${title1 || ''}`}
                  alt=""
                />
                <p
                  style={{ width: isMobile ? '100%' : 578 }}
                  className="p-1 bg-[#E2E2E2] text-[#333333] font-alhpr text-[20px]"
                >
                  {title}
                </p>
              </div>
              <NavLink isOutLink={!!outlink} to={outlink || `/wzxq/id/${id}`}>
                <img
                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                  style={{ width: 123, height: 123 }}
                  src={bofang}
                  alt=""
                />
              </NavLink>
            </div>
          ))}
        </div>
        <Pagination
          count={data?.list?.total}
          pagesize={pagesize}
          page={data?.list?.current_page}
          totalPage={data?.list?.last_page}
        />
      </Subpages>
    </Layout>
  )
}

export default Zjxc
